const getLoginURL = () => `${process.env.REACT_APP_SERVER_ENDPOINT}/login`;

export default getLoginURL;
